























import LazyHydrate from 'vue-lazy-hydration';
import { useRoute, defineComponent, useFetch } from '@nuxtjs/composition-api';
import { useUiState } from '~/composables';
import BottomNavigation from '~/components/BottomNavigation.vue';
import LoadWhenVisible from '~/components/utils/LoadWhenVisible.vue';
import { useTraverseCategory } from '~/modules/catalog/category/helpers/useTraverseCategory';
import { loadCartMixin } from '~/mixins/loadCartMixin';

export default defineComponent({
  name: 'BasicLayout',
  components: {
    LoadWhenVisible,
    LazyHydrate,
    BottomNavigation,
    ProductOmnibusPopup: () => import(/* webpackPrefetch: true */ '~/modules/catalog/product/components/ProductOmnibusPopup.vue'),
    MainHeader: () => import(/* webpackPrefetch: true */ '~/components/MainHeader/MainHeader.vue'),
    MainFooter: () => import(/* webpackPrefetch: true */ '~/components/MainFooter/MainFooter.vue'),
    WishlistSidebar: () => import(/* webpackPrefetch: true */ '~/modules/wishlist/components/WishlistSidebar.vue'),
    ScrollToTop: () => import(/* webpackPrefetch: true */ '~/components/ScrollToTop.vue'),
    CartSidebar: () => import(/* webpackPrefetch: true */ '~/modules/checkout/components/CartSidebar.vue'),
    Notification: () => import(/* webpackPrefetch: true */ '~/components/Notification.vue'),
  },

  setup() {
    loadCartMixin();
    const route = useRoute();
    const {
      isWishlistSidebarOpen, isCartSidebarOpen, isProductStickyVariantOpen,
    } = useUiState();
    const { initCategoryTree, isCategoryTreeLoaded } = useTraverseCategory();

    useFetch(async () => {
      if (!isCategoryTreeLoaded.value) {
        await initCategoryTree();
      }
    });

    return {
      isWishlistSidebarOpen,
      isCartSidebarOpen,
      route,
      isProductStickyVariantOpen,
    };
  },

  head() {
    return {
      htmlAttrs: {
        lang: this.$i18n.locale,
      },
    };
  },
});
